import BadgePermissionsCount from '../BadgePermissionsCount';
import { TableCell } from '@/components/ui';
import { IHasEmployee } from '@/interfaces';

export const DataTableBodyCellPermissions = ({ employee }: IHasEmployee) => (
  <TableCell className='py-1 pe-0'>
    <BadgePermissionsCount employee={employee} />
  </TableCell>
);

export default DataTableBodyCellPermissions;
